
































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { MissingBannersReport } from "@/models/reports";
import TableActions from "@/components/TableActions.vue";
import moment from "moment";
import { DefinitionBatch } from "@/models/definition";

import { get, head } from "lodash";
import Site from "@/models/site";
import { exportCSVFile } from "@/helpers/general";

@Component({ components: { TableActions } })
export default class MissingBannersDetails extends Vue {
  @Prop({ default: [] }) data!: MissingBannersReport[];
  @Prop() definitions!: DefinitionBatch[];
  @Prop() sites!: Site[];

  headers = [
    {
      text: this.$t("reports.missing_banners.headers.campaign"),
      sortable: false,
      value: "campaign.name",
    },
    {
      text: this.$t("reports.missing_banners.headers.site"),
      sortable: false,
      value: "siteId",
    },
    {
      text: this.$t("reports.missing_banners.headers.seller"),
      sortable: false,
      value: "campaign.user.displayName",
    },
    {
      text: this.$t("reports.missing_banners.headers.start"),
      sortable: false,
      value: "start",
    },
    {
      text: this.$t("reports.missing_banners.headers.end"),
      sortable: false,
      value: "end",
    },
    {
      text: this.$t("reports.missing_banners.headers.definitions"),
      sortable: false,
      value: "definitionValueIds",
    },
    {
      text: "",
      sortable: false,
      value: "id",
    },
  ];

  formatDate(date: Date): string {
    return moment(date).format("DD/MM/YYYY");
  }

  getDefinition(id: string): string {
    let definition;
    this.definitions.forEach((e) => {
      const value = e.values.find((d) => get(d, "id") === id);
      value ? (definition = value) : null;
    });
    return definition ? get(definition, "name") : "";
  }

  goToCampaign(id: string): void {
    let routeData = this.$router.resolve({
      name: "edit-campaign",
      params: { id: id },
    });
    window.open(routeData.href, "_blank");
  }

  getSite(id: string): string {
    const site = this.sites.find((e) => e.id === id);
    return site ? site.name : "";
  }

  exportCsv(): void {
    const headers: string[] = [];
    this.headers.forEach((h) => {
      headers.push(h.text.toString());
    });
    const data: any = [];

    this.data.forEach((d) => {
      const item = {
        campaign: d.campaign.name,
        site: this.getSite(d.siteId),
        seller: d.campaign.user?.displayName,
        start: this.formatDate(d.start),
        end: this.formatDate(d.end),
        definitions: d.definitionValueIds
          .map((def) => {
            return this.getDefinition(def);
          })
          .join(" - "),
      };
      data.push(item);
    });

    exportCSVFile(
      headers,
      data,
      `missing_banners_${moment().format("YYYY_MM_DD")}`
    );
  }
}
